import React, { PureComponent } from 'react';
require('draft-js/dist/Draft.css');
import { EditorState } from 'draft-js';
import MarkdownEditor, {
  resetStateToMarkdown,
  convertMarkdownToEditorState,
  MarkdownEditorOwnProps,
} from '../MarkdownEditor';

export interface MarkdownViewerOwnProps {
  markdown: string;
  viewerClassName?: string;
}

export type MarkdownViewerProps = MarkdownViewerOwnProps &
  Partial<MarkdownEditorOwnProps>;

export interface MarkdownViewerState {
  editorState: EditorState;
}

class MarkdownViewer extends PureComponent<
  MarkdownViewerProps,
  MarkdownViewerState
> {
  public state: MarkdownViewerState;

  constructor(props: MarkdownViewerProps) {
    super(props);

    const editorState = convertMarkdownToEditorState(props.markdown);

    this.state = { editorState };
  }

  componentDidUpdate(prevProps: MarkdownViewerProps) {
    if (prevProps.markdown !== this.props.markdown) {
      this.setState({
        editorState: resetStateToMarkdown(
          this.state.editorState,
          this.props.markdown,
        ),
      });
    }
  }

  handleStateUpdate = (editorState: EditorState) => {
    this.setState({ editorState });
  };

  render() {
    const { editorState } = this.state;

    return (
      <MarkdownEditor
        {...this.props}
        isEditing={false}
        disabled
        value={editorState}
        onChange={this.handleStateUpdate}
        editorClassName={this.props.viewerClassName}
      />
    );
  }
}

export default MarkdownViewer;
